import { all } from "redux-saga/effects";

// Action types
import * as types from "../actionTypes/service-requests.types";

// Actions
import {
  getServiceRequestsSuccess,
  approveServiceRequestsSuccess,
  declineServiceRequestsSuccess,
  openTicketDetailsSuccess,
  updateServiceRequestSuccess
} from "../actions/service-requests.actions";

// Calls
import {
  fetchServiceRequestsRequest,
  approveServiceRequest,
  declineServiceRequest,
  fetchServiceDetailsRequest,
  updateServiceRequest
} from "../../api/calls/service-requests.call";

import { fetchSaga } from "./fetch.saga";

export default function* serviceRequestsSaga() {
  yield all([
    fetchSaga({
      trigger: types.FETCH_SERVICE_REQUESTS_REQUEST,
      apiCall: fetchServiceRequestsRequest,
      onSuccess: r => getServiceRequestsSuccess(r.requests),
      failedType: types.FETCH_SERVICE_REQUESTS_FAILED
    })(),
    fetchSaga({
      trigger: types.APPROVE_SERVICE_REQUESTS_REQUEST,
      apiCall: approveServiceRequest,
      args: a => [a.serviceId, a.branchId],
      onSuccess: (r, a) => approveServiceRequestsSuccess(a.serviceId, r.message),
      failedType: types.APPROVE_SERVICE_REQUESTS_FAILED
    })(),
    fetchSaga({
      trigger: types.DECLINE_SERVICE_REQUESTS_REQUEST,
      apiCall: declineServiceRequest,
      args: a => [a.serviceId, a.declineReasonFormValues, a.branchId],
      onSuccess: (r, a) => declineServiceRequestsSuccess(a.serviceId, r.message),
      failedType: types.DECLINE_SERVICE_REQUESTS_FAILED
    })(),
    fetchSaga({
      trigger: types.OPEN_TICKET_DETAILS,
      apiCall: fetchServiceDetailsRequest,
      args: a => [a.serviceId, a.branchId],
      onSuccess: r => openTicketDetailsSuccess(r.service),
      failedType: types.OPEN_TICKET_DETAILS_FAILED
    })(),
    fetchSaga({
      trigger: types.UPDATE_SERVICE_REQUEST_REQUEST,
      apiCall: updateServiceRequest,
      args: a => [a.serviceId, a.payload],
      onSuccess: r => updateServiceRequestSuccess(r.service),
      failedType: types.UPDATE_SERVICE_REQUEST_FAILED
    })()
  ]);
}
